<template>
  <div>
    <div class="row bg-grey pt-3">
      <div class="col-12">
        <h3 class="title-h3 border-bottom pb-3">
          <button type="button" class="btn btn-back" @click="$router.push('/users')" />
          Back
        </h3>
      </div>
    </div>
    <form autocomplete="no" @submit.prevent="edit(user.id)" @keydown="clearError($event)">
      <div class="l-bg-white">
        <div class="row my-3">
          <div class="col-4">
            <div class="select-wrap">
              <label>First name</label>
              <input v-model="user.first_name" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="first_name" />
          </div>
          <div class="col-4">
            <div class="select-wrap">
              <label>Last name</label>
              <input v-model="user.last_name" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="last_name" />
          </div>
          <div class="col-4">
            <div class="select-wrap">
              <label>Username</label>
              <input v-model="user.username" type="text" class="form-control" />
            </div>
            <error-field :errors="errors" field="username" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-4">
            <div class="select-wrap">
              <label>Email</label>
              <input v-model="user.email" type="email" class="form-control" />
            </div>
            <error-field :errors="errors" field="email" />
          </div>
          <div class="col-4">
            <div class="select-wrap">
              <label>Phone</label>
              <input v-model="user.phone" type="text" class="form-control"
                     @keydown="maskPhone($event)" placeholder="Enter Phone" maxlength="14"
              />
            </div>
            <error-field :errors="errors" field="phone" />
          </div>
          <div class="col-4">
            <div class="select-wrap">
              <label>Status</label>
              <simple-select v-model="user.user_status_id"
                             :options="userStatuses"
                             placeholder="Select Status"
              />
            </div>
            <error-field :errors="errors" field="user_status_id" />
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-4">
            <div class="select-wrap h-auto">
              <label>Carriers</label>
              <key-multiselect v-model="user.carriers"
                               :clear-on-select="false"
                               :hide-selected="true"
                               :multiple="true"
                               :options="listCarriers"
                               :preserve-search="false"
                               @input="handleSelectAllCarriers"
                               label="name"
                               track-by="id"
                               v-if="userLoaded && carriers"
              >
                <template slot="tag" slot-scope="props">
                  <div class="multiselect__tag">
                    <span>{{ props.option.name }}</span>
                    <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                  </div>
                </template>
              </key-multiselect>
            </div>
            <error-field :errors="errors" field="carriers" />
          </div>
          <div class="col-4">
            <div class="select-wrap h-auto">
              <label>Role</label>
              <key-multiselect v-model="user.roles"
                               v-if="userLoaded && roles"
                               :options="rolesFromCarrier"
                               :multiple="true"
                               :clear-on-select="false"
                               :hide-selected="true"
                               :preserve-search="false"
                               label="name"
                               track-by="id"
              >
                <template slot="tag" slot-scope="props">
                  <span class="multiselect__tag">
                    <span>{{ props.option.name }}</span>
                    <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                  </span>
                </template>
              </key-multiselect>
            </div>
            <error-field :errors="errors" field="roles" />
          </div>
          <div class="col-4">
            <div class="select-wrap">
              <label>Timezone</label>
              <simple-select
                v-model="user.timezone"
                :options="timezones"
                placeholder="Select time zone"
              />
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-4">
            <div class="select-wrap">
              <label>Company</label>
              <list-multiselect
                :options="companies"
                v-model="user.companies"
                @change="options => user.companies = options"
                track-by="id"
                label="name"
              />
            </div>
            <error-field :errors="errors" field="companies" />
          </div>
          <div class="col-4">
            <div class="d-flex align-items-center pl-2">
              <span class="pr-2">
                Receive automated update emails
              </span>
              <label class="switch mr-2">
                <input type="checkbox"
                       v-model="user.receive_notifications"
                />
                <div class="slider round" />
              </label>
            </div>
          </div>
        </div>
        <template v-if="notificationTypes && notificationTypes.length">
          <div class="row mt-4">
            <div class="col">
              <h2 class="l-header-2">Notification types</h2>
            </div>
          </div>
          <section>
            <div class="row mb-2 user-role">
              <div class="col-5 d-flex justify-content-between align-items-center"
                   v-for="(type, index) in notificationTypes"
                   :key="type.id"
              >
                <div class="d-flex flex-column">
                  <span v-if="notification_type_ids.find((el) => el.via_role === true)">
                    This notification is assigned via role.
                  </span>
                  <div class="check-field">
                    <label :for="'notification_types_id-' + type.id"
                           :class="[
                             {'check-open' : notification_type_ids.find((el) => el.id === type.id)},
                             {'disabled' : notification_type_ids.find((el) => el.via_role === true)}
                           ]"
                    ><span
                      class="checkmark"
                    />{{ type.description }}<input
                      type="checkbox"
                      v-model="notification_type_ids"
                      :value="notification_type_ids.find((el) => el.id === type.id) ? notification_type_ids.find((el) => el.id === type.id) : type"
                      :key="index"
                      :id="'notification_types_id-' + type.id"
                      :disabled="notification_type_ids.find((el) => el.via_role === true)"
                      class="btn-check"
                      @change="change(type)"
                    /></label>
                  </div>
                </div>
                <div v-if="!type.disabled_only_own" class="d-flex align-items-center pl-2">
                  <span class="pr-2" :class="{'disabled' : disabledAllLeads}">
                    All leads
                  </span>
                  <label class="switch mr-2">
                    <input type="checkbox"
                           @click="toggleSwitch(notification_type_ids.find((el) => el.id === type.id))"
                           v-model="onlyOwn"
                           :value="notification_type_ids.find((el) => el.id === type.id)"
                           :disabled="disabledSwitch"
                           :class="{'disabled': disabledSwitch}"
                    />
                    <div class="slider round" />
                  </label>
                  <span :class="{'disabled' : disabledOnlyOwn}">
                    Only own
                  </span>
                </div>
              </div>
            </div>
          </section>
        </template>
        <div class="row mt-5">
          <div class="col pb-2 pt-2 text-right">
            <button class="btn btn-primary ld-ext-right"
                    v-if="$_can('clusters.users.update')"
                    :class="loadingButton ? 'running' : ''"
                    :disabled="buttonDisabled"
            >
              Save
              <div class="ld ld-ball ld-flip" />
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';
import { mapActions, mapState } from 'vuex';
import toastr from 'toastr';
import tippy from 'tippy.js';
import Errors from '../../classes/Errors';
import ErrorField from '../ErrorField';
import PhoneMask from '../../classes/PhoneMask';
import ListMultiselect from '../ListMultiselect';

export default {
  name: 'UsersEdit',

  components: {
    ListMultiselect,
    ErrorField,
  },
  data: () => ({
    user: {
      first_name: '',
      last_name: '',
      username: '',
      roles: [],
      carriers: [],
      carriers_ids: [],
      companies: [],
      email: '',
      phone: '',
      password: '',
      password_confirmation: '',
      receive_notifications: false,
    },
    notificationTypes: [],
    notification_type_ids: [],
    userLoaded: false,
    loadingButton: false,
    buttonDisabled: false,
    rolesFromCarrier: [],
    onlyOwn: [],
    phoneMask: new PhoneMask(),
    errors: new Errors(),
    listCarriers: [],
  }),
  computed: {
    ...mapState({
      roles: state => state.roles.roles,
      companies: state => state.companies.companies.data,
      carriers: state => state.carriers.carriers.data,
      userStatuses: state => state.values.userStatuses,
      timezones: state => state.timezones.timezones.data,
    }),
    disabledAllLeads() {
      return (
        this.notification_type_ids.find(el => el.only_own === true) ||
        this.notification_type_ids.find(el => el.only_own === 1)
      );
    },
    disabledOnlyOwn() {
      return (
        this.notification_type_ids.find(el => el.only_own === false) ||
        this.notification_type_ids.find(el => el.only_own === 0) ||
        this.notification_type_ids.find(el => el.only_own === null)
      );
    },
    disabledSwitch() {
      return (
        this.notification_type_ids.find(el => el.via_role === true) ||
        !this.notification_type_ids.length
      );
    },
    selectedCompanies() {
      return this.user.companies;
    },
    selectedCarriers() {
      return this.user.carriers;
    },
  },
  watch: {
    roles() {
      if (this.roles) {
        this.getRolesFromCarriers();
      }
    },
    carriers(val) {
      this.listCarriers = [{ id: 'SELECTED_ALL', name: 'Select all carriers' }, ...val];
    },
  },
  mounted() {
    this.getUser(this.$route.params.id);
    this.getAllNotificationTypes();
    this.getTimezones();
    this.listCarriers = [{ id: 'SELECTED_ALL', name: 'Select all carriers' }, ...this.carriers];
    this.$nextTick(() => {
      window.$('input').attr('autocomplete', 'no');
    });
    tippy('.popup', {
      placement: 'bottom',
      html: '#myTemplate',
    });
  },
  methods: {
    ...mapActions(['removeUser', 'getTimezones']),
    handleSelectAllCarriers() {
      this.getRolesFromCarriers();
      let hasToSelectAll = false;
      let hastToDeselectAll = false;
      this.selectedCarriers.forEach(carrierId => {
        if (carrierId === 'SELECTED_ALL') {
          hasToSelectAll = true;
        }
        if (carrierId === 'DESELECT_ALL') {
          hastToDeselectAll = true;
        }
      });
      if (hastToDeselectAll) {
        this.$set(this.user, 'carriers', []);
        this.listCarriers = [
          { id: 'SELECTED_ALL', name: 'Select all companies' },
          ...this.carriers,
        ];
      }

      if (hasToSelectAll) {
        this.$set(this.user, 'carriers', this.carriers.map(company => company.id));
        this.listCarriers = [{ id: 'DESELECT_ALL', name: 'Deselect all' }, ...this.carriers];
      }
    },
    toggleSwitch(type) {
      type.only_own = !type.only_own;
      this.sync(type);
    },
    change(type) {
      if (this.notification_type_ids.find(el => el.id === type.id)) {
        this.give(type);
      } else {
        this.revoke(type);
      }
    },
    give(type) {
      if (type.only_own === null) {
        type.only_own = 0;
      }
      axios.post(`/clusters/users/${this.user.id}/notification-types/give`, {
        notification_types: [
          {
            notification_type_id: type.id,
            only_own: type.only_own,
          },
        ],
      });
    },
    revoke(type) {
      if (type.only_own === null) {
        type.only_own = 0;
      }
      axios.post(`/clusters/users/${this.user.id}/notification-types/revoke`, {
        notification_types: [
          {
            notification_type_id: type.id,
            only_own: type.only_own,
          },
        ],
      });
    },
    sync(type) {
      if (type.only_own === null) {
        type.only_own = 0;
      }
      axios.post(`/clusters/users/${this.user.id}/notification-types`, {
        notification_types: [
          {
            notification_type_id: type.id,
            only_own: type.only_own,
          },
        ],
      });
    },
    getUser(id) {
      axios
        .get(`clusters/users/${id}`)
        .then(res => {
          this.user = res.data.data;
        })
        .then(() => {
          this.$set(this.user, 'phone', this.phoneMask.maskedPhone(this.user.phone));
          this.$set(this.user, 'carriers', this.user.carriers.map(el => el.id));
          this.$set(this.user, 'companies', this.user.companies.map(el => el.id));
          this.$set(this.user, 'roles', this.user.roles.map(el => el.id));
          this.getNotificationTypes(this.user.id);
          if (this.roles) {
            this.getRolesFromCarriers();
          }
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.userLoaded = true;
        });
    },
    edit(id) {
      this.buttonDisabled = true;
      this.loadingButton = true;
      this.$set(this.user, 'phone', this.user.phone.replace(/\D/g, ''));
      axios
        .put(`clusters/users/${id}`, { ...this.user })
        .then(() => {
          toastr.success('Successfully updated user.');
          this.$router.push('/users');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
          this.buttonDisabled = false;
        });
    },
    deleteUser(id) {
      this.removeUser(id)
        .then(() => {
          this.$router.push('/users');
          toastr.success('Successfully deleted user');
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getRolesFromCarriers() {
      const carriers = this.user.carriers.slice();
      this.rolesFromCarrier = this.roles.filter(
        role => carriers.includes(role.carrier_id) || !role.carrier_id || role.carrier_id === 0,
      );
    },
    getAllNotificationTypes() {
      axios
        .get('/notification-types')
        .then(res => {
          this.notificationTypes = res.data.data;
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    getNotificationTypes(id) {
      axios
        .get(`/clusters/users/${id}/notification-types`)
        .then(res => {
          this.notification_type_ids = res.data.data;
          this.onlyOwn = res.data.data.filter(el => el.only_own === 1);
        })
        .catch(err => this.errors.record(err.response.data.error));
    },
    clearError(event) {
      this.errors.clear(event.target.name);
    },
    maskPhone(event) {
      this.$nextTick(() => {
        this.$set(this.user, 'phone', this.phoneMask.maskedPhone(this.user.phone));
        this.clearError(event);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.switch {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 18px;
}

.switch input {
  display: none;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: -2px;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

.slider:before {
  position: absolute;
  content: '';
  height: 10px;
  width: 10px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}

input:focus + .slider {
  box-shadow: 0 0 1px #101010;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}
.check-field {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/users/UsersEdit.vue